export function getTransportDistance(
  transportData: TransportEndpointResponse | null | undefined
): AirportDistance[] | undefined {
  return hasDistance(transportData) ? transportData?.distances : undefined;
}

export function hasDistance(transportData: TransportEndpointResponse | null | undefined): boolean {
  return (
    transportData !== null &&
    transportData !== undefined &&
    transportData.distances !== undefined &&
    transportData.distances?.length !== 0
  );
}

export function mapTransportDistance(
  distanceToHotelData: AirportsDistanceResponse | TrainDistanceResponse | null | undefined
) {
  const distancesData: TransportDistances = distanceToHotelData?.length
    ? isAirportsDistance(distanceToHotelData)
      ? mapAirportDistances(distanceToHotelData as AirportsDistanceResponse)
      : mapTrainDistances(distanceToHotelData as TrainDistanceResponse)
    : [];

  return distancesData;
}

function mapAirportDistances(distanceToHotelData: AirportsDistanceResponse): TransportDistances {
  return distanceToHotelData.map(({ iata, distanceWithUnit }) => ({ code: iata, distanceWithUnit }));
}

function mapTrainDistances(distanceToHotelData: TrainDistanceResponse): TransportDistances {
  return distanceToHotelData.map(({ id, distanceWithUnit }) => ({ code: id, distanceWithUnit }));
}

function isAirportsDistance(
  distanceData: AirportsDistanceResponse | TrainDistanceResponse | undefined | null
): distanceData is AirportsDistanceResponse {
  return (
    distanceData !== undefined &&
    distanceData !== null &&
    distanceData.length > 0 &&
    (distanceData as AirportsDistanceResponse)[0].iata !== undefined
  );
}
